<template>
  <b-modal
    :id="id"
    v-model="shown"
    :size="modalOptions.size"
    :lazy="true"
    scrollable
    :hide-header="true"
    :hide-footer="true"
    @show="beforeShown"
    @shown="onShown"
    @hide="beforeHidden"
    @hidden="onHidden"
  >
    <!-- :adaptive="true" -->
    <!-- :width="modalOptions.width" -->
    <!-- :height="modalOptions.height" -->
    <!-- transition="poc-modal-fade" -->
    <!-- @before-open="beforeOpen" -->
    <!-- @before-close="beforeClose" -->
    <!-- @opened="onShown" -->
    <!-- @closed="onHidden" -->
    <slot />
  </b-modal>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: () => '',
    },
    options: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      shown: false,
      deleteModal: false,
      disableModal: false,
      defaultOptions: {
        // height: 'auto',
        // width: 600,
        size: 'xl',
      },
    };
  },

  computed: {
    modalOptions() {
      const modalOptions = { ...this.defaultOptions, ...this.options };
      // console.log(`${this.id} modal options`, modalOptions);
      return modalOptions;
    },
  },

  mounted() {
    Bus.$on('hide_all_modals', (except) => {
      if (this.shown && this.id !== except) {
        // console.log(`hiding modal ${this.id}`);
        this.shown = false;
      }
    });

    Bus.$on('toggle_modal', (modalId) => {
      if (this.id === modalId) {
        this.shown = !this.shown;
      }
    });
  },

  beforeDestroy() {
    Bus.$off('hide_all_modals');
    Bus.$off('toggle_modal');
  },

  methods: {

    beforeShown() {
      // Bus.$emit('hide_all_modals');

      // console.log(`modal ${this.id} shown`);
      // this.shown = true;
    },

    beforeHidden() {
      // console.log(`modal ${this.id} hidden`);
      // this.shown = false;
    },

    onShown() {
      this.$emit('opened');
    },

    onHidden() {
      this.$emit('closed');
    },
  },
};
</script>

<style>
.modal .modal-body {
  padding: 10px;
}

.modal .modal-xl {
  max-width: 95vw;
}
/* .poc-modal-fade-enter, */
/* .poc-modal-fade-leave-to { */
/* opacity: 0; */
/* } */
/*  */
/* .poc-modal-fade-leave, */
/* .poc-modal-fade-enter-to { */
/* opacity: 1; */
/* } */
/*  */
/* .poc-modal-fade-enter-active, */
/* .poc-modal-fade-leave-active { */
/* -webkit-transition: all 0.3s ease-out; */
/* -o-transition: all 0.3s ease-out; */
/* transition: all 0.3s ease-out; */
/* } */
/*  */
/* .poc-modal-fade-enter { */
/* transform: translateY(25%); */
/* } */
/*  */
/* .poc-modal-fade-enter-to { */
/* transform: translateY(0); */
/* } */
/*  */
/* .poc-modal-fade-leave { */
/* transform: translateY(0); */
/* } */
/*  */
/* .poc-modal-fade-leave-to { */
/* transform: translateY(-25%); */
/* } */
/*  */
/* .overlay-fade-enter-active, */
/* .overlay-fade-leave-active { */
/* transition: all 0.3s; */
/* } */
/*  */
/* .overlay-fade-enter, */
/* .overlay-fade-leave-active { */
/* opacity: 0; */
/* } */
</style>
